<div *ngIf="block && !isSecondLevelUp"
    class="container-page-general position-relative d-flex flex-column justify-content-end align-items-center">
    <div class="container-page-general__title w-100 text-center">
        <img loading="lazy" *ngIf="block.foto && imgPath" [src]="imgPath" [alt]="'profile picture ' + block.nome + ' ' + block.cognome">
        <h1 *ngIf="block.nome && block.cognome" class="ls-h1-page-title text-brand-10 text-start text-lg-center px-3 px-lg-0 mb-4"
            [innerHTML]="block.nome + ' ' + block.cognome"></h1>
        <p *ngIf="block.carica" class="text-neutral-40 ls-p mb-0" [innerHTML]="block.carica"></p>
    </div>
    <div class="container-page-general__container-share cursor-pointer" (click)="nodeService.openModaleShare()">
        <p class="m-0 ls-label-medium-semibold text-uppercase">{{"MODAL_SHARE.SEND_TO" | translate}}</p>
        <img loading="lazy" src="../../../../../../assets/images/share-icon/share-icon-yellow.png" alt="share icon">
    </div>
    <div class="container-page-general__container-share-icon cursor-pointer" (click)="nodeService.openModaleShare()">
        <img loading="lazy" src="../../../../../../assets/images/share-icon/share-icon-yellow.png" alt="share icon">
    </div>
</div>
<ng-container *ngIf="node && block && isSpinner; else spinner">
    <!-- <div *ngIf="isSecondLevelUp" class="container-field-taxonomies"> -->
    <div class="container-field-taxonomies">
        <!-- DEFAULT PAGINA FIELD -->
        <app-container-field-taxonomies [dataFieldTaxonomies]="dataFieldTaxonomies" [typeOfContent]="'docente'"></app-container-field-taxonomies>
        <!-- END DEFAULT PAGINA FIELD -->
    </div>
    <!-- Anchor -->
    <app-sample-anchor *ngIf="anchorItems && !isSecondLevelUp" [anchorItems]="anchorItems" [idAnchor]="idAnchor" [docentiAnchorlength]="anchorLength"
        [positionType]="'py-2'" [bgColor]="'#FAFAFA'" [setOffset]="120" [positionTop]="'120px'" [styleHeader]="'second'" [isDocentiPage]="true">
    </app-sample-anchor>
    <!-- END Anchor -->
    <!-- HEADER COLLAPSE -->
    <div id="collapse" [ngClass]="{
            'opacity-100 visible bg-neutral-A1': isCollapseHeader,
            'opacity-0 invisible bg-neutral-99': !isCollapseHeader
        }" class="container-page-general-collapse position-fixed no-print">
        <div class="container-page-general-collapse__item text-md-center d-flex justify-content-between align-items-center border-bottom-custom" [ngClass]="{'bg-neutral-99': !isCollapseHeader}">
            <div *ngIf="isShowLocalMenu" class="d-flex align-items-end container-icon-expand m-auto col-1">
                <img loading="lazy" *ngIf="isSecondLevelUp" class="cursor-pointer hidden-phone" src="../../../../../../assets/images/side-menu-expand.svg" alt="menu expand" style="margin-left: 34px;" (click)="openMenu()">
            </div>
            <p *ngIf="block.nome && block.cognome" class="ls-h1-page-title-collapse col-10 mb-1" [ngClass]="{'offset-1': !isShowLocalMenu}" [innerHTML]="block.nome + ' ' + block.cognome"></p>
            <div class="d-flex justify-content-end align-items-center col-1" [ngClass]="{
                'col-1': (block.nome && block.cognome) && isShowLocalMenu,
                'col-11': (!block.nome && block.cognome) && isShowLocalMenu,
                'col-12': (!block.nome && block.cognome) && !isShowLocalMenu
            }">
                <div class="cursor-pointer" (click)="nodeService.openModaleShare()">
                    <img loading="lazy" src="../../../../../../assets/images/share-icon/share-icon-yellow.png" alt="share icon" style="margin-right: 34px;">
                </div>
            </div>
        </div>
        <div *ngIf="!isSecondLevelUp && anchorItems.length" class="border-bottom-custom" style="padding: 16px 10px;" [ngClass]="{'bg-neutral-99': !isCollapseHeader}">
            <app-sample-anchor *ngIf="anchorItems" [anchorItems]="anchorItems" [styleHeader]="'collapse'" [isDocentiPage]="true" [docentiAnchorlength]="anchorLength"
                [positionTop]="'140px'" [bgColor]="'transparent'" [setOffset]="300">
            </app-sample-anchor>
        </div>
    </div>
    <!-- END HEADER COLLAPSE -->
    <!-- CURRICULUM -->
    <div class="bg-neutral-99">
        <div *ngIf="cv" class="container container-curriculum">
            <h2 class="ls-h2-section-title text-brand-10 text-center">{{"CONTENT_TYPES.PAGE_DOCENTI.CURRICULUM_VITAE" | translate}}</h2>
            <div #content class="position-relative"
                [style.height]="showMore ? 'auto' : visibleHeight + 'px'"
                [style.overflow-y]="showMore ? 'visible' : 'hidden'"
            >
                <article class="ls-p text-neutral-30 pb-5" [innerHTML]="cv"></article>
                <div *ngIf="!showMore && content.scrollHeight > visibleHeight" class="fade-overlay"></div>
            </div>
            <div *ngIf="content.scrollHeight > visibleHeight" class="w-100 d-flex justify-content-center" style="padding: 40px 0 80px 0;">
                <p class="text-uppercase ls-label-small-semibold text-brand-40 cursor-pointer" (click)="showMore = !showMore">
                    {{ showMore ? ("CONTENT_TYPES.PAGE_DOCENTI.READ_LESS" | translate) : ("CONTENT_TYPES.PAGE_DOCENTI.KEEP_READING" | translate) }}
                </p>
            </div>
        </div>
    </div>
    <div class="container" id="informazioni">
        <div class="container-info d-flex flex-wrap justify-content-between align-items-stretch">
            <div class="p-3 col-12 col-lg-6 flex-grow-1" *ngIf="block.note_sui_contatti || block.note_sui_link_personali || block.email">
                <div class="container-info__contatti card h-100">
                    <div *ngIf="block.note_sui_contatti || block.email">
                        <h3 class="ls-h3-item-small text-brand-10">{{"CONTENT_TYPES.PAGE_DOCENTI.CONTACTS" | translate}}</h3>
                        <div class="mb-1">
                            <a *ngIf="block.email" class="ls-p-small text-brand-40" [href]="'mailto:' + block.email" [innerHTML]="block.email"></a>
                        </div>
                        <div *ngIf="block.note_sui_contatti" class="text-neutral-30 ls-p-small" [innerHTML]="block.note_sui_contatti"></div>
                    </div>
                    <div *ngIf="block.note_sui_link_personali || block.link_personali.length">
                        <h3 class="ls-h3-item-small text-brand-10">{{"CONTENT_TYPES.PAGE_DOCENTI.PERSONAL_LINKS" | translate}}</h3>
                        <ng-container *ngIf="block.link_personali && block.link_personali.length">
                            <div *ngFor="let link of block.link_personali">
                                <a  class="ls-p-small"
                                    [ngClass]="{'text-brand-40': link.url}" 
                                    [href]="link.url ? link.url : '#'" 
                                    [innerHTML]="link.label" target="{{isExternalLink(link.url) ? '_blank' : '_self'}}">
                                </a>
                            </div>
                        </ng-container> 
                        <ng-container *ngIf="block.note_sui_link_personali">
                            <div class="ls-p-small text-neutral-30" [innerHTML]="block.note_sui_link_personali"></div>
                        </ng-container>
                    </div>
                </div>
            </div>
            <div class="p-3 col-12 col-lg-6 flex-grow-1" *ngIf="block.orari_di_ricevimento">
                <div class="container-info__ricevimento card h-100">
                    <!-- TODO orari -->
                    <h3 class="ls-h3-item-small text-brand-10">{{"CONTENT_TYPES.PAGE_DOCENTI.RECEPTION_HOURS" | translate}}</h3>
                    <div class="ls-p-small text-neutral-30" [innerHTML]="block.orari_di_ricevimento"></div>
                </div>
            </div>
        </div>
    </div>
    <!-- END CURRICULUM -->
    <div *ngIf="block.field_descrizione" class="container container-description mt-5"
        [innerHTML]="block.field_descrizione">
    </div>
    <!-- VISTA AVVISI -->
    <div *ngIf="dataAvvisi && dataAvvisi.length" class=" container-view" id="avvisi">
        <app-sample-view-content-related [relatedData]="dataAvvisi" [oggetto_view]="'avvisi'" [titleSection]="'CONTENT_TYPES.TITLE_RELATED_NOTICES'"></app-sample-view-content-related>
    </div>
    <!-- END VISTA AVVISI -->
    <!-- TABLE DIDATTICA -->
    <div *ngIf="block.insegnamenti_esse3 && block.insegnamenti_esse3.length" class="container-lg" id="didattica">
        <h2 class="ls-h2-section-title text-brand-10 text-center my-5">
            {{"CONTENT_TYPES.PAGE_DOCENTI.DIDACTICS_AND_TEACHING" | translate}}</h2>
        <div class="table-responsive">
            <table class="table">
                <thead>
                    <tr>
                        <th scope="col" class="ls-label-small-semibold text-uppercase">
                            {{"CONTENT_TYPES.PAGE_DOCENTI.TEACHING" | translate}}
                        </th>
                        <th scope="col" class="ls-label-small-semibold text-uppercase">
                            {{"CONTENT_TYPES.PAGE_DOCENTI.ACADEMIC_YEAR" | translate}}
                        </th>
                        <th scope="col" class="ls-label-small-semibold text-uppercase">
                            {{"CONTENT_TYPES.PAGE_DOCENTI.STUDY_PATH" | translate}}
                        </th>
                        <th scope="col" class="ls-label-small-semibold text-uppercase">
                            {{"CONTENT_TYPES.PAGE_DOCENTI.CFU" | translate}}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let didattica of block.insegnamenti_esse3;">
                        <th class="" scope="row">
                            <p class="m-0 text-brand-40 ls-p cursor-pointer" [innerHTML]="didattica.cds.cds_nome"
                                (click)="modaleDidatticaDettaglio(didattica)">
                            </p>
                        </th>
                        <td class="">
                            <p class="m-0 ls-p text-neutral-30" [innerHTML]="didattica.aaOffID + ' / ' + (didattica.aaOffID + 1)"></p>
                        </td>
                        <td class="">
                            <p class="m-0 ls-p text-neutral-30" [innerHTML]="didattica.cds.pdsDes"></p>
                        </td>
                        <td class="">
                            <p class="m-0 ls-p text-neutral-30" [innerHTML]="didattica.peso | number"></p>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <!-- END TABLE DIDATTICA -->
    <!-- ALTRI INSEGNAMENTI -->
    <div class="container">
        <div *ngIf="block.altre_info_insegnamento.length" class=" container-didattica">
            <h2 class="ls-h2-section-title text-brand-10 text-center">
                {{"CONTENT_TYPES.PAGE_DOCENTI.MORE_INFO_ON_THE_TEACHINGS" | translate}}</h2>
            <app-sample-accordion [block]="block.altre_info_insegnamento" [view]="'docente'"></app-sample-accordion>
        </div>
        <!-- <div class="container-ricerca" *ngIf="keywords.length"> -->
        <div class="container-ricerca">
            <h2 *ngIf="block.ricerche_pubblicazioni.length || keywords.length || pubblicazioniFirst.length"
                class="ls-h2-section-title text-brand-10 text-center" id="ricerca">
                {{"CONTENT_TYPES.PAGE_DOCENTI.RESEARCH" | translate}}
            </h2>
            <p *ngIf="keywords.length"
                class="container-ricerca__text ls-label-small-semibold text-uppercase text-brand-10 text-center">
                {{"CONTENT_TYPES.PAGE_DOCENTI.RESEARCH_AREAS_OF_THE_TEACHER" | translate}}
            </p>
            <div *ngIf="keywords.length" class="container-ricerca__keywords d-flex flex-wrap justify-content-center">
                <p *ngFor="let item of keywords"
                    class="bg-neutral-95 text-support-30 ls-label-small-semibold text-uppercase"
                    [innerHTML]="item.name"></p>
            </div>
            <p *ngIf="block.ricerche_pubblicazioni.length"
                class="container-ricerca__text ls-label-small-semibold text-uppercase text-brand-10 text-center">
                {{"CONTENT_TYPES.PAGE_DOCENTI.PUBLICATIONS_AND_RESEARCH" | translate}}
            </p>
            <div *ngIf="block.ricerche_pubblicazioni.length">
                <owl-carousel-o *ngIf="block.ricerche_pubblicazioni.length > 4" [options]="customOptionsOwl"
                    class="position-relative" [id]="'sample-view-carousel-ricerca'">
                    <ng-container *ngFor="let ricerche of block.ricerche_pubblicazioni; let idx = index">
                        <ng-template carouselSlide let-owlItem>
                            <div class="container-faq bg-neutral-A1 position-relative m-3">
                                <div class="container-faq__category">
                                    <p *ngIf="ricerche.area_tematica"
                                        class="container-faq__category__taxonomy ls-label-small-semibold text-neutral-60 text-uppercase"
                                        [innerHTML]="ricerche.area_tematica"></p>
                                    <h3 *ngIf="ricerche.titolo" class="ls-h3-item-title-small"
                                        [ngClass]="ricerche.link ? 'cursor-pointer' : ''" [innerHTML]="ricerche.titolo">
                                    </h3>
                                    <p *ngIf="ricerche.descrizione" [innerHTML]="ricerche.descrizione"></p>
                                </div>
                                <a *ngIf="!isExternalLink(ricerche.link)" [routerLink]="navigationService.splitUrlRouterLink(ricerche.link).path" [queryParams]="navigationService.splitUrlRouterLink(ricerche.link).queryParams">
                                    <div class="container-faq__button-bottom">
                                        <div
                                            class="m-0 ls-label-medium-semibold container-faq__button-bottom__button text-brand-40 line-discover-with-icon">
                                            <p class="ls-label-medium-semibold text-uppercase">{{"FIND_OUT" | translate}}</p>
                                            <i class="fa-solid fa-arrow-right text-brand-40 pb-4" aria-hidden="true"></i>
                                        </div>
                                    </div>
                                </a>
                                <a *ngIf="isExternalLink(ricerche.link)" [href]="ricerche.link">
                                    <div class="container-faq__button-bottom">
                                        <div
                                            class="m-0 ls-label-medium-semibold container-faq__button-bottom__button text-brand-40 line-discover-with-icon">
                                            <p class="ls-label-medium-semibold text-uppercase">{{"FIND_OUT" | translate}}</p>
                                            <i class="fa-solid fa-arrow-right text-brand-40 pb-4" aria-hidden="true"></i>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </ng-template>
                    </ng-container>
                </owl-carousel-o>
                <ng-container *ngIf="block.ricerche_pubblicazioni.length <= 4">
                    <div class="d-flex"
                        [ngClass]="block.ricerche_pubblicazioni.length < 4 ? 'justify-content-center' : 'justify-content-between'">
                        <div *ngFor="let ricerche of block.ricerche_pubblicazioni"
                            class="container-faq bg-neutral-A1 position-relative m-3">
                            <div class="container-faq__category">
                                <p *ngIf="ricerche.area_tematica"
                                    class="container-faq__category__taxonomy ls-label-small-semibold text-neutral-60 text-uppercase"
                                    [innerHTML]="ricerche.area_tematica"></p>
                                <h3 *ngIf="ricerche.titolo" class="ls-h3-item-title-small cursor-pointer"
                                    [innerHTML]="ricerche.titolo"></h3>
                                <p *ngIf="ricerche.descrizione" [innerHTML]="ricerche.descrizione"></p>
                            </div>
                            <a *ngIf="ricerche.link && !isExternalLink(ricerche.link)" [routerLink]="navigationService.splitUrlRouterLink(ricerche.link).path" [queryParams]="navigationService.splitUrlRouterLink(ricerche.link).queryParams">
                                <div class="container-faq__button-bottom">
                                    <div
                                        class="m-0 ls-label-medium-semibold container-faq__button-bottom__button text-brand-40 line-discover-with-icon">
                                        <p class="ls-label-medium-semibold text-uppercase">{{"FIND_OUT" | translate}}</p>
                                        <i class="fa-solid fa-arrow-right text-brand-40 pb-4" aria-hidden="true"></i>
                                    </div>
                                </div>
                            </a>
                            <a *ngIf="ricerche.link && isExternalLink(ricerche.link)" [href]="ricerche.link" target="_blank">
                                <div class="container-faq__button-bottom">
                                    <div
                                        class="m-0 ls-label-medium-semibold container-faq__button-bottom__button text-brand-40 line-discover-with-icon">
                                        <p class="ls-label-medium-semibold text-uppercase">{{"FIND_OUT" | translate}}</p>
                                        <i class="fa-solid fa-arrow-right text-brand-40 pb-4" aria-hidden="true"></i>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
    <!-- ALTRI INSEGNAMENTI -->
    <!-- PUBBLICAZIONI -->
    <div class="container" *ngIf="block.recupera_info_ricerca_scientifica && pubblicazioniFirst && pubblicazioniFirst.length">
        <div class="container-all-pubblications my-5">
            <div class="container-all-pubblications__container-title bg-brand-99 d-flex justify-content-center align-items-center">
                <p class="ls-label-medium-semibold text-uppercase text-brand-40 text-center m-0">
                    {{"CONTENT_TYPES.PAGE_DOCENTI.ALL_PUBLICATIONS" | translate}}
                </p>
            </div>
            <div class="container-all-pubblications__container-items">
                <ul>
                    <li *ngFor="let pubblicazione of pubblicazioniFirst" [innerHTML]="pubblicazione.description"></li>
                    <ng-container *ngIf="isOtherPub">
                        <li *ngFor="let pubblicazione of pubblicazioniOther" [innerHTML]="pubblicazione.description"></li>
                    </ng-container>
                </ul>
                <div class="pt-4 d-flex justify-content-center align-items-center">
                    <p class="text-uppercase ls-label-small-semibold text-brand-40 m-0 d-flex cursor-pointer" (click)="isOtherPub = !isOtherPub">
                        {{ (!isOtherPub ? 'CONTENT_TYPES.PAGE_DOCENTI.SHOW_ALL' : 'CONTENT_TYPES.PAGE_DOCENTI.SHOW_LESS') | translate }}
                    </p>    
                </div>
            </div>
        </div>
    </div>
    <div class="container" *ngIf="!block.recupera_info_ricerca_scientifica && (block.pubblicazioni && block.pubblicazioni[0] && block.pubblicazioni[0].value)">
        <div class="container-all-pubblications my-5">
            <div class="container-all-pubblications__container-title bg-brand-99 d-flex justify-content-center align-items-center">
                <p class="ls-label-medium-semibold text-uppercase text-brand-40 text-center m-0">
                    {{"CONTENT_TYPES.PAGE_DOCENTI.ALL_PUBLICATIONS" | translate}}
                </p>
            </div>
            <div class="container-all-pubblications__container-items">
                <p [innerHTML]="block.pubblicazioni[0].value"></p>
            </div>
        </div>
    </div>
    <!-- END PUBBLICAIONI -->
    <!-- RIGHE -->
    <ng-container *ngIf="node.field_layout_righe && node.field_layout_righe.length">
        <div class="container-row">
            <div *ngFor="let row of node.field_layout_righe; let idx = index">
                <app-row [lang]="node.langcode[0].value" [rowId]="row.target_id" [position]="idx" [attr.rowid]="row.target_id"
                    [preview]="node.preview" (objAnchor)="addNewAnchorItem($event)" [isDocentiPage]="true">
                </app-row>
            </div>
        </div>
    </ng-container>

    <!-- END RIGHE -->
    <!-- MODALE -->
    <ng-template #modalDidatticaDettaglio let-modal>
        <ng-container *ngIf="dataInsegnamento; else isSpinnerModale">
            <div class="container-header bg-brand-99">
                <div class="container-header__top-bar d-flex justify-content-between align-items-center text-uppercase">
                    <div class="col-1"></div>
                    <p *ngIf="dataInsegnamento.cds.cds_nome"
                        class="col-10 ls-label-medium-semibold text-brand-40 text-center m-0" id="modal-basic-title"
                        [innerHTML]="dataInsegnamento.cds.cds_nome"></p>
                    <div class="col-1 close cursor-pointer text-center" aria-label="Close" (click)="modal.dismiss()">
                        <i class="fa-solid fa-plus text-brand-40" style="transform: rotate(45deg);" aria-hidden="true"></i>
                    </div>
                </div>
            </div>
            <div class="d-flex flex-wrap container-body">
                <div class="container-body__column-left p-4 col-12 col-lg-4">
                    <!-- <div *ngIf="dataInsegnamento.cds.cds_nome" class="d-flex container-body__column-left__item"
                        style="gap: 24px;">
                        <div class="container-body__column-left__item__title col-6">
                            <p class="ls-label-small-semibold text-brand-10 text-uppercase">
                                {{"CONTENT_TYPES.PAGE_DOCENTI.DEGREE_COURSE" | translate}}</p>
                        </div>
                        <div class="container-body__column-left__item__text col-6">
                            <p class="ls-p-small text-neutral-30" [innerHTML]="dataInsegnamento.cds.cds_nome"></p>
                        </div>
                    </div>
                    <div *ngIf="dataInsegnamento.cds.cds_nome"
                        class="d-flex container-body__column-left__item" style="gap: 24px;">
                        <div class="container-body__column-left__item__title col-6">
                            <p class="ls-label-small-semibold text-brand-10 text-uppercase">
                                {{"CONTENT_TYPES.PAGE_DOCENTI.PATH" | translate}}</p>
                        </div>
                        <div class="container-body__column-left__item__text col-6">
                            <p class="ls-p-small text-neutral-30"
                                [innerHTML]="dataInsegnamento.cds.cds_nome"></p>
                        </div>
                    </div> -->
                    <div *ngIf="dataInsegnamento.aaOffID" class="d-flex container-body__column-left__item"
                        style="gap: 24px;">
                        <div class="container-body__column-left__item__title col-6">
                            <p class="ls-label-small-semibold text-brand-10 text-uppercase">
                                {{"CONTENT_TYPES.PAGE_DOCENTI.A.A" | translate}}</p>
                        </div>
                        <div class="container-body__column-left__item__text col-6">
                            <p class="ls-p-small text-neutral-30" [innerHTML]="dataInsegnamento.aaOffID + ' / ' + (dataInsegnamento.aaOffID + 1)"></p>
                        </div>
                    </div>
                    <div *ngIf="dataInsegnamento.part_descr" class="d-flex container-body__column-left__item"
                        style="gap: 24px;">
                        <div class="container-body__column-left__item__title col-6">
                            <p class="ls-label-small-semibold text-brand-10 text-uppercase">
                                {{"CONTENT_TYPES.PAGE_DOCENTI.SEMESTER" | translate}}</p>
                        </div>
                        <div class="container-body__column-left__item__text col-6">
                            <p class="ls-p-small text-neutral-30" [innerHTML]="dataInsegnamento.part_descr"></p>
                        </div>
                    </div>
                    <div *ngIf="block.nome && block.cognome" class="d-flex container-body__column-left__item"
                        style="gap: 24px;">
                        <div class="container-body__column-left__item__title col-6">
                            <p class="ls-label-small-semibold text-brand-10 text-uppercase">
                                {{"CONTENT_TYPES.PAGE_DOCENTI.TEACHERS" | translate}}</p>
                        </div>
                        <div class="container-body__column-left__item__text col-6">
                            <p class="ls-p-small text-neutral-30" [innerHTML]="block.nome + ' ' + block.cognome">
                            </p>
                        </div>
                    </div>
                    <div *ngIf="dataInsegnamento.lingua_insegnamento" class="d-flex container-body__column-left__item"
                        style="gap: 24px;">
                        <div class="container-body__column-left__item__title col-6">
                            <p class="ls-label-small-semibold text-brand-10 text-uppercase">
                                {{"CONTENT_TYPES.PAGE_DOCENTI.LANGUAGE" | translate}}</p>
                        </div>
                        <div class="container-body__column-left__item__text col-6">
                            <p class="ls-p-small text-neutral-30" [innerHTML]="dataInsegnamento.lingua_insegnamento">
                            </p>
                        </div>
                    </div>
                    <div *ngIf="dataInsegnamento.ssd" class="d-flex container-body__column-left__item"
                        style="gap: 24px;">
                        <div class="container-body__column-left__item__title col-6">
                            <p class="ls-label-small-semibold text-brand-10 text-uppercase">
                                {{"CONTENT_TYPES.PAGE_DOCENTI.SSD" | translate}}</p>
                        </div>
                        <div class="container-body__column-left__item__text col-6">
                            <p class="ls-p-small text-neutral-30" [innerHTML]="dataInsegnamento.ssd"></p>
                        </div>
                    </div>
                    <div *ngIf="dataInsegnamento.peso" class="d-flex container-body__column-left__item"
                        style="gap: 24px;">
                        <div class="container-body__column-left__item__title col-6">
                            <p class="ls-label-small-semibold text-brand-10 text-uppercase">
                                {{"CONTENT_TYPES.PAGE_DOCENTI.CFU" | translate}}</p>
                        </div>
                        <div class="container-body__column-left__item__text col-6">
                            <p class="ls-p-small text-neutral-30" [innerHTML]="dataInsegnamento.peso"></p>
                        </div>
                    </div>
                    <div *ngIf="dataInsegnamento.ore" class="d-flex container-body__column-left__item"
                        style="gap: 24px;">
                        <div class="container-body__column-left__item__title col-6">
                            <p class="ls-label-small-semibold text-brand-10 text-uppercase">
                                {{"CONTENT_TYPES.PAGE_DOCENTI.HOURS" | translate}}</p>
                        </div>
                        <div class="container-body__column-left__item__text col-6">
                            <p class="ls-p-small text-neutral-30" [innerHTML]="dataInsegnamento.ore"></p>
                        </div>
                    </div>
                    <!-- <div class="d-flex container-body__column-left__item" style="gap: 24px;">
                        <div class="container-body__column-left__item__title col-6">
                            <p class="ls-label-small-semibold text-brand-10 text-uppercase">Partizioni</p>
                        </div>
                        <div class="container-body__column-left__item__text col-6">
                            <p class="ls-p-small text-neutral-30"
                                *ngFor="let partizione of dataStep2.partizioni; let idx = index"
                                [innerHTML]="idx !== (dataStep2.partizioni.length - 1) ? partizione.nome_partizione + ', ' : partizione.nome_partizione">
                            </p>
                        </div>
                    </div> -->
                </div>
                <div class="container-body__column-right p-4 col-12 col-lg-8">
                    <div class="container-body__column-right__alert"></div>
                    <div class="container-body__column-right__text">
                        <div *ngIf="dataInsegnamento.contenuti">
                            <p class="ls-pb-h2 text-brand-10">{{"CONTENT_TYPES.PAGE_DOCENTI.CONTENTS" | translate}}</p>
                            <p class="ls-p text-neutral-30" [innerHTML]="formatHtml(dataInsegnamento.contenuti)">
                                {{dataInsegnamento.contenuti}}</p>
                        </div>
                        <div *ngIf="dataInsegnamento.metodo">
                            <p class="ls-pb-h2 text-brand-10">{{"CONTENT_TYPES.PAGE_DOCENTI.METHOD" | translate}}</p>
                            <p class="ls-p text-neutral-30" [innerHTML]="formatHtml(dataInsegnamento.metodo)"></p>
                        </div>
                        <div *ngIf="modalitaApprendimento">
                            <p class="ls-pb-h2 text-brand-10"
                                [innerHTML]="'CONTENT_TYPES.PAGE_CORSO_DI_STUDI.LEARNING_VERIFICATION_MODE' | translate">
                            </p>
                            <p class="ls-p text-neutral-30" [innerHTML]="formatHtml(modalitaApprendimento)"></p>
                        </div>
                        <div *ngIf="dataInsegnamento.obiettivi_formativi">
                            <p class="ls-pb-h2 text-brand-10">{{"CONTENT_TYPES.PAGE_DOCENTI.EDUCATIONAL_TARGETS" |
                                translate}}</p>
                            <p class="ls-p text-neutral-30" [innerHTML]="formatHtml(dataInsegnamento.obiettivi_formativi)"></p>
                        </div>
                        <div *ngIf="dataInsegnamento.prerequisiti">
                            <p class="ls-pb-h2 text-brand-10">{{"CONTENT_TYPES.PAGE_DOCENTI.PREREQUISITES" | translate}}
                            </p>
                            <p class="ls-p text-neutral-30" [innerHTML]="formatHtml(dataInsegnamento.prerequisiti)"></p>
                        </div>
                        <div *ngIf="dataInsegnamento.testi_riferimento">
                            <p class="ls-pb-h2 text-brand-10">{{"CONTENT_TYPES.PAGE_DOCENTI.REFERENCE_TEXTS" |
                                translate}}</p>
                            <p class="ls-p text-neutral-30" [innerHTML]="formatHtml(dataInsegnamento.testi_riferimento)"></p>
                        </div>
                        <div *ngIf="dataInsegnamento.obiettivi_sviluppo_sostenibile" class="mb-5">
                            <p class="ls-pb-h2 text-brand-10">{{"CONTENT_TYPES.PAGE_DOCENTI.REFERENCE_TEXTS" |
                                translate}}</p>
                            <p class="ls-p text-neutral-30"
                                [innerHTML]="formatHtml(dataInsegnamento.obiettivi_sviluppo_sostenibile)">
                            </p>
                        </div>
                        <div *ngIf="dataInsegnamento.other_info" class="mb-5">
                            <p class="ls-pb-h2 text-brand-10">{{"CONTENT_TYPES.PAGE_DOCENTI.OTHER_INFO" |
                                translate}}</p>
                            <p class="ls-p text-neutral-30"
                                [innerHTML]="formatHtml(dataInsegnamento.other_info)">
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </ng-template>
    <!-- END MODALE -->
    <!-- SPINNER -->
    <ng-template #isSpinnerModale>
        <app-spinner></app-spinner>
    </ng-template>
</ng-container>
<!-- SPINNER -->
<ng-template #spinner>
    <app-spinner></app-spinner>
</ng-template>